
import { Vue } from "vue-class-component";

export default class CodrejDex extends Vue {}
